import { render, staticRenderFns } from "./submit_students.vue?vue&type=template&id=4fe29376&scoped=true"
import script from "./submit_students.vue?vue&type=script&lang=js"
export * from "./submit_students.vue?vue&type=script&lang=js"
import style0 from "./submit_students.vue?vue&type=style&index=0&id=4fe29376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe29376",
  null
  
)

export default component.exports